import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { deepOrange, deepPurple, red, brown, lightBlue, lightGreen, amber, pink, teal, grey, cyan, indigo, blue, orange, blueGrey } from '@mui/material/colors';

function getColor(name) {
  const colors = [red, deepOrange, deepPurple, brown, lightBlue, lightGreen, amber, pink, cyan, indigo, blue, orange, blueGrey, teal];
  const index = name.charCodeAt(0) % colors.length;
  return colors[index][500];
}

const NameLetter = (props) => {
  const name = props.nameLetter
  const color = getColor(name);
  return (
    <>
    {props.nameType == 'icon' ? 
      <Avatar component={'span'} sx={{ bgcolor: color, width: '34px', height: '34px', mr: 1, textTransform: 'uppercase'}}>{name}</Avatar>
    :
      <Typography component={'div'} sx={{fontSize: "1.5rem", color: color}}>
        {name ? name : ''}
      </Typography>
    }
    </>
  );
};

export default NameLetter;
